import Snackbar from '@mui/material/Snackbar'
import tw, { styled } from 'twin.macro'

export const StyledSnackbar = styled(Snackbar)(() => [tw`[max-width:96vw] sm:max-w-xl`])
